export default __webpack_public_path__ + "static/media/jyoti-singh.b6d81def.webp";